import React, { useEffect, useState } from "react";
import Select from "react-select";

import { productsService } from "../../api/products.service";

const modelOptions = [
	{ value: "1", label: "Global Models" },
	{ value: "2", label: "Australian/New Zealand Models" },
];

function Step1({
	selected,
	handleStep1Change,
	setIsOpenModels,
	setCredits,
	setIdProduct,
	credits,
	combinations,
}) {
	const [baseCredit, setBaseCredit] = useState(0);
	const [loadError, setLoadError] = useState(false);
	const selectedModel = String(selected.ml_model || "1");
	const currentModel = modelOptions.find((option) => option.value === selectedModel) || modelOptions[0];

	useEffect(() => {
		let cancelled = false;
		productsService
			.list("premium", 3)
			.then((response) => {
				if (cancelled) return;
				const product = response.results.find((item) => item.product_type === "premium");
				if (product) {
					setBaseCredit(product.amount);
					setIdProduct(product.id);
				}
				setLoadError(false);
			})
			.catch(() => {
				if (!cancelled) setLoadError(true);
			});
		return () => {
			cancelled = true;
		};
	}, [setIdProduct]);

	useEffect(() => {
		setCredits(baseCredit > 0 && combinations > 0 ? baseCredit * combinations : 0);
	}, [baseCredit, combinations, setCredits]);

	return (
		<section className="multi-builder-card" aria-labelledby="multi-setup-title">
			<div className="multi-builder-card__header">
				<div className="multi-builder-card__title">
					<span>1</span>
					<div><h2 id="multi-setup-title">Report setup</h2><p>Give this batch a name and choose the model for every combination.</p></div>
				</div>
				<div className="multi-builder-cost" aria-live="polite">
					<span>Total request</span>
					<strong><i className="fa fa-coins" aria-hidden="true" /> {credits} credits</strong>
					<small>{combinations} combination{combinations === 1 ? "" : "s"}{baseCredit ? ` × ${baseCredit}` : ""}</small>
				</div>
			</div>

			{loadError ? <div className="multi-builder-notice" role="alert">Credit pricing could not be loaded. Refresh before generating a report.</div> : null}

			<div className="multi-builder-fields">
				<div>
					<label htmlFor="multi-report-name">Report name</label>
					<input
						id="multi-report-name"
						type="text"
						value={selected.name || ""}
						onChange={(event) => handleStep1Change({ name: event.target.value })}
						placeholder="e.g. Spring breeding shortlist"
						autoComplete="off"
					/>
					<small>This name will appear in your multi-report history.</small>
				</div>
				<div>
					<label htmlFor="multi-report-model">Analysis model</label>
					<div className="multi-builder-model">
						<Select
							inputId="multi-report-model"
							options={modelOptions}
							value={currentModel}
							onChange={(option) => handleStep1Change({ ml_model: option?.value || "1" })}
							className="react-select-container"
							classNamePrefix="react-select"
							isClearable={false}
						/>
						<button type="button" onClick={() => setIsOpenModels(true)} aria-label="Learn about analysis models" title="Learn about analysis models">
							<i className="fa fa-question-circle" aria-hidden="true" />
						</button>
					</div>
					<small>{selectedModel === "2" ? "Best for Australian and New Zealand bloodlines." : "Best for international bloodlines and general analysis."}</small>
				</div>
			</div>
		</section>
	);
}

export default Step1;
